var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slide-title font-vectrex text-uppercase text-4xl lg:text-7xl mb-10 lg:mb-0 px-3 lg:p-12 xl:pr-[300px] line-clamp-3 xl:line-clamp-2"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }